import { Box } from "@mui/material";
import CustomContainer from "components/common/CustomContainer";
import NoDataBanner from "components/common/NoDataBanner";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import MetricDetails from "components/features/dashboard/MetricDetails";
import PlanBadge from "components/features/dashboard/PlanBadge";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getHoursAndMin, getPlanDetail } from "utils/CommonFunctions";
import "./index.scss";

interface props {
  plansList?: any;
}
export default function (props: props) {
  const navigate = useNavigate();

  const { plansList } = props;

  const metricsPlansList = useAppSelector((state) => state.hotelUserDashboardSlice.suggestedPlans.plansMetrics);

  return (
    <>
      {plansList?.length > 0 ? (
        <div className="plans-component">
          {plansList?.map((plan: any) => {
            const metrics = getPlanDetail(plan?.id, metricsPlansList)?.metrics;
            return (
              <CustomContainer
                scroll="full"
                variant="light"
                onClick={() => navigate(`/plandetails/${plan.id}`, { state: { showMetrics: true } })}
                className="plans-wrapper"
              >
                <div className="timing-wrapper">
                  <PlanBadge data={plan} />
                  <div></div>
                  <Timing duration={getHoursAndMin(plan?.timeEstimateMinutes)} />
                </div>

                <Typography variant="body2" showBold color={tokens.Text.General.PrimaryHeadline}>
                  {plan.name}
                </Typography>

                {metrics && (
                  <div className="metrics-wrapper">
                    {Object.keys(metrics).map((metric: any) => {
                      return (
                        <MetricDetails
                          key={metric}
                          metric={metrics[metric]}
                          metricsBar={false}
                          sx={{ display: "flex", justifyContent: "center" }}
                        />
                      );
                    })}
                  </div>
                )}
              </CustomContainer>
            );
          })}
        </div>
      ) : (
        <>
          <Box className="no-plans-banner">
            <NoDataBanner />
          </Box>
        </>
      )}
    </>
  );
}
